import { generateGUID } from "@/utils/guid";
import { FormSection } from "../types";

export const createFormSection = ():FormSection => {
	return {
		id: `s-${generateGUID()}`,
		items: [],
		settings:{
			itemSelection:null
		}
	};
};